import { OnboardingAppGuard } from "./Guards/OnboardingAppGuard";
import { TenantAccountAppGuard } from "./Guards/TenantAccountAppGuard";
import { UserAccountAppGuard } from "./Guards/UserAccountAppGuard";

/** Renders all app guards. */
export default function AppGuards() {
  return (
    <>
      {/* TODO: implement guards as pipeline so they are executed in order and don't compete with each other. */}
      {/* Idea: define guards per area. */}
      {/* Plus: think how to avoid guards redirecting user away from important pages like accept invite. */}

      {/* Disable as it breaks invites logic by redirecting user from invite pages. */}
      {/* <UserProfileAppGuard /> */}

      <TenantAccountAppGuard />
      <UserAccountAppGuard />
      <OnboardingAppGuard />
    </>
  );
}
